export default "__VITE_ASSET__li_ZUcKO__"